
import { IDataDriver, ICsvDriverConfig } from "./../types";
import { IAnyObj } from "@dhx/ts-common/types";
export interface ICsvDriver extends IDataDriver {
	getFields(data: string, headers?: string[]);
}
export class CsvDriver implements ICsvDriver {
	public config: ICsvDriverConfig;

	constructor(config?: ICsvDriverConfig) {

		const initConfig: ICsvDriverConfig = {
			skipHeader: 0,
			nameByHeader: false,
			rowDelimiter: "\n",
			columnDelimiter: ",",
		};

		this.config = { ...initConfig, ...config };

		if (this.config.nameByHeader) {
			this.config.skipHeader = 1;
		}
	}

	getFields(row: string, headers?: string[]): { [key: string]: any } {
		const parts = row.trim().split(this.config.columnDelimiter);

		const obj = {};
		for (let i = 0;i < parts.length;i++) {
			obj[headers ? headers[i] : i + 1] = parts[i];
		}

		return obj;
	}
	getRows(data: string): string[] {
		return data.trim().split(this.config.rowDelimiter);
	}
	toJsonArray(data: string): any[] {
		const rows = this.getRows(data);
		let names = this.config.names;

		if (this.config.skipHeader) {
			const top = rows.splice(0, this.config.skipHeader);
			if (this.config.nameByHeader) {
				names = top[0].trim().split(this.config.columnDelimiter);
			}
		}
		return rows.map(row => this.getFields(row, names));
	}
	serialize(data: IAnyObj[], withoutHeader?: boolean): string {
		const header = data[0] ? Object.keys(data[0])
			.filter(key => key[0] !== "$")
			.join(this.config.columnDelimiter) : "";

		const readyData = this._serialize(data);
		if (withoutHeader) {
			return readyData;
		}
		return header + readyData;
	}
	private _serialize(data: IAnyObj[]): string {
		return data.reduce((csv, row) => {
			const cells = Object.keys(row).reduce((total, key, i) => {
				if (key[0] === "$" || key === "items") {
					return total;
				}
				return `${total}${row[key]}${i === row.length - 1 ? "" : this.config.columnDelimiter}`;
			}, "");

			if (row.items) {
				return `${csv}\n${cells}${this._serialize(row.items)}`;
			}

			return `${csv}${this.config.rowDelimiter}${cells}`;
		}, "");
	}
}